import { Direction } from "../types";
import CalendarBody from "./CalendarBody";
import CalendarHeader from "./CalendarHeader";
import { useState } from "react";
import { getWeekInterval } from "./CalendarBody/utils";
import { CarouselWrapper } from "./StyledComponents";

interface Props {
    moveSlide?: (direction: Direction) => void;
    week?: number;
    setWeeks: React.Dispatch<React.SetStateAction<number[]>>;
}

const Calendar = ({ moveSlide, week, setWeeks }: Props) => {
    // Ez egy display dolog, legyen 2 date inkább
    const [weekInterval, setWeekInterval] = useState<readonly [Date, Date]>(
        () => getWeekInterval(0)
    );

    if (!moveSlide || !week) {
        return null;
    }

    return (
        <CarouselWrapper>
            <CalendarHeader
                week={week}
                weekInterval={weekInterval}
                moveSlide={moveSlide}
                setWeeks={setWeeks}
            />
            <CalendarBody week={week} setWeekInterval={setWeekInterval} />
        </CarouselWrapper>
    );
};

export default Calendar;
